import { render, staticRenderFns } from "./TempRegistrationPage.vue?vue&type=template&id=b0c83f02&scoped=true"
import script from "./TempRegistrationPage.vue?vue&type=script&lang=js"
export * from "./TempRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./TempRegistrationPage.vue?vue&type=style&index=0&id=b0c83f02&prod&scoped=true&lang=css"
import style1 from "./TempRegistrationPage.vue?vue&type=style&index=1&id=b0c83f02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c83f02",
  null
  
)

export default component.exports